<template>
  <div :class="['video-container']" ref="container">
    
    <div class="canvasSection">
      <div class="slotContent">
        <slot></slot>
      </div>
      <canvas ref="canvas"></canvas>
    </div>
    
    
  </div>
</template>

<script>
export default {
  props: {
    itemIndex: { type: Number, required: true },
    mode:{type:String,require:true},
    frameCount: { type: Number, required: true },
    // can be a function: i => `path/frame_${String(i).padStart(3,'0')}.webp`
    // OR a string pattern: "path/frame_{i}.webp" (uses pad prop)
    framePath: { type: [Function, String], required: true },
    pad: { type: Number, default: 3 } // number of digits for padding
  },
  data() {
    return {
      elementInView:false,
      images: [],
      ctx: null,
      dpr: window.devicePixelRatio || 1,
      lastFrameIndex: 0,
      firstLoaded: false
    };
  },
  watch: {
    elementInView(newVal, oldVal) {
      //alert("index="+this.itemIndex+" inview="+this.elementInView);
      this.$emit("onViewChange",{index:this.itemIndex,val:newVal});
    }
  },

  mounted() {
    this.ctx = this.$refs.canvas.getContext("2d");
    this.resizeCanvas();
    window.addEventListener("resize", this.resizeCanvas);
    window.addEventListener("scroll", this.onScroll);
    this.preloadImages();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeCanvas);
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    // support string pattern with {i} or a function
    getSrc(i) 
    {
      //return "video/sequnces/lynx3/lynx_bg3_001.webp";

      if (typeof this.framePath === "function") 
      {
        return this.framePath(i);
      }
      // string pattern: replace {i} or {index}
      const pad = String(i).padStart(this.pad, "0");
      return String(this.framePath).replace(/\{(?:i|index)\}/g, pad);
    },

    preloadImages() {
      var vm=this;
      // allocate array
      //alert("this.frameCount="+this.frameCount);
      this.images = new Array(this.frameCount);
      for (let i = 0; i < this.frameCount; i++) {
        const img = new Image();
        var tempSrc = this.getSrc(i);        
        img.onload = () => {
          if (!this.firstLoaded) 
          {            
            this.firstLoaded = true;
            this.render(0);
          }
        };
        img.src = tempSrc;        
        this.images[i] = img;
      }
    },

    resizeCanvas() {
      const canvas = this.$refs.canvas;
      const cssW = window.innerWidth;
      const cssH = window.innerHeight;

      // keep CSS size for layout
      canvas.style.width = cssW + "px";
      canvas.style.height = cssH + "px";

      // backing store size (account for DPR)
      canvas.width = Math.round(cssW * this.dpr);
      canvas.height = Math.round(cssH * this.dpr);

      // make draw operations use CSS pixels
      this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);

      // redraw last frame
      this.render(this.lastFrameIndex);
    },

    render(index) 
    {
      const img = this.images[index];
      if (!img || !img.complete || img.naturalWidth === 0) return;

      const canvas = this.$refs.canvas;
      const canvasW = canvas.width / this.dpr; // CSS px
      const canvasH = canvas.height / this.dpr;

      const imgW = img.naturalWidth;
      const imgH = img.naturalHeight;

      const canvasAspect = canvasW / canvasH;
      const imgAspect = imgW / imgH;

      let sx, sy, sWidth, sHeight;

      if (imgAspect > canvasAspect) {
        // image is wider -> crop left/right
        sHeight = imgH;
        sWidth = Math.round(sHeight * canvasAspect);
        sx = Math.round((imgW - sWidth) / 2);
        sy = 0;
      } else {
        // image is taller -> crop top/bottom
        sWidth = imgW;
        sHeight = Math.round(sWidth / canvasAspect);
        sx = 0;
        sy = Math.round((imgH - sHeight) / 2);
      }

      this.ctx.clearRect(0, 0, canvasW, canvasH);
      this.ctx.drawImage(img, sx, sy, sWidth, sHeight, 0, 0, canvasW, canvasH);

      this.lastFrameIndex = index;
    },

    onScroll() {
      const container = this.$refs.container;
      const rect = container.getBoundingClientRect();
      const totalScroll = rect.height - window.innerHeight;

      this.elementInView = this.isElementInView(container);


      let scrollTop = -rect.top;
      scrollTop = Math.max(0, Math.min(scrollTop, Math.max(0, totalScroll)));

      let scrollFraction;
      if (totalScroll <= 0) {
        scrollFraction = rect.top < 0 ? 1 : 0;
      } else {
        scrollFraction = scrollTop / totalScroll;
      }

      // flip if needed: scrollFraction = 1 - scrollFraction;
      const frameIndex = Math.floor(scrollFraction * (this.frameCount - 1));
      requestAnimationFrame(() => this.render(frameIndex));
    },

    isElementInView(el, fullyInView = false) 
    {
      const rect = el.getBoundingClientRect();
      const viewHeight = window.innerHeight || document.documentElement.clientHeight;
      const viewWidth = window.innerWidth || document.documentElement.clientWidth;

      if (fullyInView) {
        // Element must be fully inside the viewport
        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= viewHeight &&
          rect.right <= viewWidth
        );
      } else {
        // Element is partially visible
        return (
          rect.top < viewHeight &&
          rect.bottom > 0 &&
          rect.left < viewWidth &&
          rect.right > 0
        );
      }
    }
    



    
  }
};

/////////////////////////*  */////////////////////////////////////////////////////////
</script>



<style scoped>
    .video-container {
        /* height: 200vh; */
        height: 200vh;
        width: 100%;
        background: #222;
        position: relative;
    }


    .canvasSection
    {
        position: sticky;
        top: 0;
        width: 100%;
        height: 100vh;
        display: block;
        z-index: 1000;
    }
    canvas {
        width: 100%;
        height: 100vh;
        position: absolute;top: 0px;left: 0px;
        z-index: 1000;
    }

    .___canvas {
        position: sticky;
        top: 0;
        width: 100%;
        height: 100vh;
        display: block;
        z-index: 1000;
    }
    .slotContent
    {
        position: absolute;top: 0px;left: 0px;
        display: block;
        z-index: 2000;
    }
</style>
